import { SectionWrapper } from "../../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../../ui-components/pageLayout/TableSettingsComponents";
import { FieldArray } from "formik";
import { BasicTable } from "../../../../../Table/BasicTable";
import { ProductsTableSettings } from "../ProductsTableSettings";
import { fromJson } from "../../../../../../models/modelHelpers";
import {
  FEATURE_SET_FEATURES,
  FeatureSetProduct,
} from "../../../../../../models/Offerings/featureSet";
import SimpleButton from "../../../../ui-components/buttons/SimpleButton";
import { Modal } from "../../../../../Modal/Modal";
import React, { useState, Fragment } from "react";
import { Buttons, CustomModalWrapper, ModalField } from "../FeatureSet";
import { NendaProduct } from "@nendaTypes/NendaTypes";

const FeatureSetProductAccordion: React.FC = () => {
  const [displayModal, setDisplayModal] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<string>();
  const [selectedFeatures, setSelectedFeatures] = useState<string[]>([]);

  const featuresOnChange = (event, key: string) => {
    if (!event.target.checked) {
      setSelectedFeatures(
        selectedFeatures.filter((feature) => feature !== key)
      );
    } else {
      setSelectedFeatures([...selectedFeatures, key]);
    }
  };

  return (
    <SectionWrapper>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Products
        </AccordionSummary>
        <AssetAccordionDetails>
          <FieldArray
            name="products"
            render={({ move, push, remove, form }) => (
              <>
                {!!form.values.products?.length && (
                  <BasicTable
                    tableSettings={ProductsTableSettings((index) =>
                      remove(index)
                    )}
                    tableData={
                      form.values.products?.map((product) =>
                        fromJson(FeatureSetProduct, product)
                      ) || []
                    }
                  />
                )}
                <Buttons>
                  <SimpleButton
                    text="Add"
                    onClick={() => setDisplayModal(true)}
                    size="small"
                  />
                </Buttons>
                <CustomModalWrapper>
                  <Modal
                    style={{}}
                    visible={displayModal}
                    onClose={() => setDisplayModal(false)}
                    title={"Add new product"}
                    onSubmit={() => {
                      push({
                        product: selectedProduct,
                        features: selectedFeatures,
                      });
                      setSelectedFeatures([]);
                      setSelectedProduct(undefined);
                    }}
                    closeOnSubmit={true}
                  >
                    <ModalField>
                      <label className="first-label">Chose a product:</label>
                      {Object.keys(NendaProduct).map((key) => (
                        <Fragment key={key}>
                          <label className="checkbox-label">
                            {NendaProduct[key]}
                          </label>
                          <input
                            type="checkbox"
                            checked={selectedProduct === key}
                            onChange={() => setSelectedProduct(key)}
                          />
                        </Fragment>
                      ))}
                    </ModalField>
                    <ModalField>
                      <label className="first-label">Chose features:</label>
                      {Object.keys(FEATURE_SET_FEATURES).map((key) => (
                        <Fragment key={key}>
                          <label className="checkbox-label">
                            {FEATURE_SET_FEATURES[key]}
                          </label>
                          <input
                            type="checkbox"
                            checked={selectedFeatures.includes(key)}
                            onChange={(ev) => featuresOnChange(ev, key)}
                          />
                        </Fragment>
                      ))}
                    </ModalField>
                  </Modal>
                </CustomModalWrapper>
              </>
            )}
          />
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default FeatureSetProductAccordion;
